import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { comnUtils, comnEnvs } from "@/comn/utils";
import { Grid } from "@/comn/components";
import { Page, Group, Layout, Button } from "@/comn/components";
import { useForm, useFetch, useGrid, usePopup, useStore, useToast, useModal } from "@/comn/hooks";
import { BASE, APIS, SF_DCLT_SRCH, SG_DCLT_LIST } from "./services/ComnCdService";
import { Link } from "react-router-dom";

export const DcltList = (props: any) => {
    const pgeUid = "dcltLst";
    const { t } = useTranslation();
    const { pgeStore, setStore } = useStore({ pgeUid: pgeUid });
    const toast = useToast();
    const modal = useModal();
    const params = props.params;

    const form = {
        dcltSrch: useForm({
            defaultSchema: SF_DCLT_SRCH,
            // defaultValues: { ...pgeStore?.form } || {},
        }),
    };

    const grid = {
        dcltLst: useGrid({
            defaultSchema: SG_DCLT_LIST,
            page: pgeStore?.page,
            size: pgeStore?.size,
        }),
    };

    const fetch = {
        getDcltLst: useFetch({
            api: (page = grid.dcltLst.page) => {
                return APIS.getDcltLst(form.dcltSrch.getValues(), page, grid.dcltLst.size);
            },
            enabled: comnUtils.isEmpty(form.dcltSrch.errors) && form.dcltSrch.isSubmitted,
            key: [grid.dcltLst.page, grid.dcltLst.size],
            onSuccess: () => {
                setStore(pgeUid, {
                    form: form.dcltSrch.getValues(),
                    page: grid.dcltLst.page,
                    size: grid.dcltLst.size,
                });
            },
        }),
    };

    const handler = {
        click_Btn_Srch: () => {
            form.dcltSrch.handleSubmit(
                () => {
                    grid.dcltLst.setPage(0);
                    fetch.getDcltLst.fetch(0);
                },
                () => {
                    toast.showToast({ type: "warning", content: "msg.00002" });
                },
            )();
        },

        /* * */
        click_Btn_Apply: () => {
            const list: any[] = grid.dcltLst.getChecked() || [];
            if (comnUtils.isEmpty(list)) {
                modal.openModal({ content: "msg.com.00086" });
                return;
            }

            props?.callback?.({ data: list });
            modal.closeModal(props.id);
        },
    };

    const render = {
        grid_DcltLst: {
            cell: {
                dcltTin: (arg: any) => {
                    const { binding, rowValues, value } = arg;
                    return (
                        <Link
                            to={"#"}
                            onClick={(e) => {
                                e.preventDefault();
                                props?.callback?.({ code: value, label: rowValues.dcltNm });
                                modal.closeModal(props.id);
                            }}
                        >
                            {arg.value}
                        </Link>
                    );
                },
            },
        },
    };

    useEffect(() => {
        handler.click_Btn_Srch();
        /* * */
        if (params?.multiple === true) {
            grid.dcltLst.setOption("checkbox", true);
        }
    }, []);

    return (
        <Page title={t("T_DCLT_LST")} info={true}>
            <form>
                <Group>
                    <Group.Body>
                        <Group.Section>
                            <Group.Row>
                                <Group.Control {...form.dcltSrch.schema.dcltTin}></Group.Control>
                                <Group.Control {...form.dcltSrch.schema.dcltNm}></Group.Control>
                            </Group.Row>
                        </Group.Section>
                        <Layout direction="row">
                            <Layout.Left>
                                <Button
                                    role="reset"
                                    onClick={() => {
                                        form.dcltSrch.reset();
                                    }}
                                ></Button>
                            </Layout.Left>
                            <Layout.Right>
                                <Button
                                    role="search"
                                    onClick={() => {
                                        handler.click_Btn_Srch();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    </Group.Body>
                </Group>
            </form>

            <Group>
                <Group.Body>
                    {/* * */}
                    {params?.multiple === true && (
                        <Layout>
                            <Layout.Right>
                                <Button
                                    role="apply"
                                    onClick={() => {
                                        handler.click_Btn_Apply();
                                    }}
                                ></Button>
                            </Layout.Right>
                        </Layout>
                    )}
                    <Grid {...grid.dcltLst.grid} data={fetch.getDcltLst.data?.dcltList} render={render.grid_DcltLst} />
                </Group.Body>
            </Group>
        </Page>
    );
};
